module.exports = __webpack_public_path__ + "upload-big.png?51a2e5d89033d75c73d508c3848081f1";